import { startWith } from 'rxjs/operators';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseSiteService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';

@Component({
  selector: 'kn-br-custom-section',
  templateUrl: './kn-br-custom-section.component.html',
  styleUrl: './kn-br-custom-section.component.scss',
})
export class KnBrCustomSectionComponent implements OnInit, OnDestroy {
  name: string;
  title: string;
  componentData$ = this.component.data$;
  subscriptions = new Subscription();
  items$ = this.knbrCommonService.loadComponentData$();
  sectionComponentsData;
  baseSite: any;

  constructor(
    public component: CmsComponentData<any>,
    public knbrCommonService: KnBrCommonService,
    protected router: Router,
    private cdr: ChangeDetectorRef,
    private baseSiteService: BaseSiteService
  ) {}

  ngOnInit(): void {
    this.baseSiteService.get().subscribe((site) => (this.baseSite = site?.uid || ''));
    this.component.data$.subscribe((data) => {
      this.name = data.name;
      this.title = data.title;
      let componentsList = data.tiles.trim().split(' ');
      if (componentsList.length > 6) {
        componentsList = componentsList.slice(0, 6);
      }
      this.knbrCommonService.getWhatsNewDataForMultipleComponents(componentsList).subscribe((combineddata) => {
        this.sectionComponentsData = [...combineddata];
        this.cdr.detectChanges();
      });
    });
  }

  clickActionOfCard(link) {
    if (link.startsWith('https://')) {
      window.location.href = link;
    } else {
      this.router.navigateByUrl(link);
      window.scroll(0,0)
    }
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
